module.exports = __webpack_public_path__ + "img/company.fc2d2bab.png";